


















import { FormQuestion } from "@/store/modules/types";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";

@Component
export default class TextAnswer extends Vue {
  @Prop() readonly question!: FormQuestion;
  text = "";
  @Watch("text")
  onTextChanged() {
    this.$emit("answer", this.question.id, this.text);
  }
  mounted() {
    const { answer } = this.question;
    if (answer.value) this.text = answer.value;
  }
}
